import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'dg-fontresizer',
  templateUrl: './dg-fontresizer.component.html',
  styleUrls: ['./dg-fontresizer.component.scss'],
  standalone: true,
  imports: [DragDropModule, MatButtonModule],
})
export class DgFontresizerComponent implements OnInit {
  count = null;
  getHtml = document.body.parentElement;
  constructor() {}

  ngOnInit(): void {}
  fontInc(): void {
    console.log('I am In');
    this.count += 1;
    if (this.count > 0 && this.count <= 2) {
      this.getHtml.className = 'zoom-plus-' + this.count;
    } else if (this.count == 0) {
      this.fontdefault();
    } else if (this.count < 0 && this.count >= -2) {
      document.body.parentElement.className = 'zoom-dec' + this.count;
    } else {
      this.count -= 1;
    }
  }
  fontdefault(): void {
    this.count = 0;
    document.body.parentElement.className = 'zoom-default';
  }
  fontdec(): void {
    this.count -= 1;
    if (this.count > 0 && this.count <= 2) {
      this.getHtml.className = 'zoom-plus-' + this.count;
    } else if (this.count == 0) {
      this.fontdefault();
    } else if (this.count < 0 && this.count >= -2) {
      document.body.parentElement.className = 'zoom-dec' + this.count;
    } else {
      this.count += 1;
    }
  }
}
